import { Injectable } from '@angular/core';
import {environment} from '../../../../environments/environment';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {Notification} from '../../../models/notification.interface';

const URL_BASE = `${environment.URL_BACKEND}/notification`;

@Injectable({
  providedIn: 'root'
})
export class NotificationService {

  constructor(
      private readonly http: HttpClient
  ) { }

  getNotifications(idUsuario: number): Observable<Notification[]> {
    return this.http.get<Notification[]>(`${URL_BASE}/${idUsuario}`);
  }
  delete(id: number): Observable<Notification> {
    return this.http.delete<Notification>(`${URL_BASE}/${id}`);
  }
  update(notification: Notification): Observable<Notification> {
    return this.http.put<Notification>(URL_BASE, notification);
  }



}
